import { customElement, children } from "aurelia-framework";

@customElement("toolbar")
export class Toolbar {
    @children items;
}

